import React from 'react';
import styles from './budgetStatsBox.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import FormatService from 'src/services/format.service';
import adobeTags from 'src/types/adobe-tags';
import { BudgetModel } from 'src/types/budget.model';
import BudgetService from 'src/services/budget.service';
import { CategoryModel } from 'src/types/category.model';
import Divider from 'src/components/atomic/atoms/divider/Divider';
import BudgetSummaryStat from 'src/components/atomic/molecules/budgetSummaryStat/BudgetSummaryStat';
import Selectors from 'src/utils/selectors';

interface BudgetStatsBoxProps {
    budgets: BudgetModel[];
    categories: CategoryModel[];
    pathname: string;
    isMinWidthSmall?: boolean;
    isMinWidthMedium?: boolean;
}

export default function BudgetStatsBox({
    budgets,
    categories,
    pathname,
    isMinWidthSmall,
    isMinWidthMedium
}: BudgetStatsBoxProps): JSX.Element {
    const budgetForTrackedCategories: number = BudgetService.getAllParentCategoriesTotal(budgets);
    const totalSpent: number = BudgetService.currentlySpentCategoryTotal(budgets, categories);
    const leftOver: number = budgetForTrackedCategories - totalSpent > 0 ? budgetForTrackedCategories - totalSpent : 0;

    return (
        <div className={styles.statsBox} data-cy={Selectors.SpendSmart.BUDGET_STATS_BOX}>
            <BudgetSummaryStat
                title={LiteralsService.getLiteral('BudgetStatsBox.budgetForTrackedCategoriesTitle')}
                tooltip={LiteralsService.getLiteral('BudgetStatsBox.budgetForTrackedCategoriesTooltip')}
                amount={FormatService.formatCurrency(budgetForTrackedCategories, { round: true })}
                tagName={adobeTags.Tooltip.BudgetStatsBox.Budget}
                pathname={pathname}
                isMinWidthSmall={isMinWidthSmall}
                isMinWidthMedium={isMinWidthMedium}
            />
            <Divider
                color="weak"
                className={isMinWidthSmall && !isMinWidthMedium ? styles.verticalDivider : ''}
                orientation={isMinWidthSmall && !isMinWidthMedium ? 'vertical' : 'horizontal'}
            />
            <BudgetSummaryStat
                title={LiteralsService.getLiteral('BudgetStatsBox.totalSpentBudgetCategoriesTitle')}
                tooltip={LiteralsService.getLiteral('BudgetStatsBox.totalSpentBudgetCategoriesTooltip')}
                amount={FormatService.formatCurrency(totalSpent)}
                tagName={adobeTags.Tooltip.BudgetStatsBox.TotalSpent}
                pathname={pathname}
                isMinWidthSmall={isMinWidthSmall}
                isMinWidthMedium={isMinWidthMedium}
            />
            <Divider
                color="weak"
                className={isMinWidthSmall && !isMinWidthMedium ? styles.verticalDivider : ''}
                orientation={isMinWidthSmall && !isMinWidthMedium ? 'vertical' : 'horizontal'}
            />
            <BudgetSummaryStat
                title={LiteralsService.getLiteral('BudgetStatsBox.leftOverBudgetCategoriesTitle')}
                tooltip={LiteralsService.getLiteral('BudgetStatsBox.leftOverBudgetCategoriesTooltip')}
                amount={FormatService.formatCurrency(leftOver)}
                tooltipClassName={styles.thirdTooltip}
                isGreen={leftOver > 0}
                tagName={adobeTags.Tooltip.BudgetStatsBox.LeftOver}
                pathname={pathname}
                isMinWidthSmall={isMinWidthSmall}
                isMinWidthMedium={isMinWidthMedium}
            />
        </div>
    );
}
